import client from '../../api/client';

/**
 * Product Permissions Module
 * Combines DataTable management, AJAX form loading, and permission logic.
 */
const ProductPermissions = {
    // Cache for our ajaxed forms
    formsCache: {},

    init() {
        this.initializeDataTable();
        this.bindEvents();
    },

    /**
     * Initializes the DataTable and custom search
     */
    initializeDataTable() {
        const table = $('.permissions').DataTable({
            "dom": 't',
            "paging": false,
            "info": false,
            "order": []
        });

        $("#table-search input").on('keyup', function() {
            table.search(this.value).draw();
        });

        // Store table instance for event access
        this.table = table;
    },

    bindEvents() {
        const $doc = $(document);


        // DataTable Child Row / Form Toggle
        $doc.on('click', '.js-permission-form-toggle', (e) => {
            const $btn = $(e.currentTarget);
            const componentID = $btn.data('component-id');
            const $tr = $btn.closest('tr');
            const row = this.table.row($tr);

            if (row.child.isShown()) {
                // Cache form before hiding
                const $form = $tr.next('tr').find('.permissionForm');
                this.formsCache[$form.attr('id')] = $form;

                row.child.hide();
                $tr.removeClass('shown');
            } else {
                const formID = `permissionForm${componentID}`;

                if (this.formsCache[formID] !== undefined) {
                    this.appendPermissionForm(this.formsCache[formID], $tr, row);
                } else {
                    this.getPermissionForm(formID, componentID, $tr, row, e.currentTarget);
                }
            }
        });

        // Status Change Logic
        $doc.on('click', '.changeProductStatus:not(.active)', (e) => {
            const $el = $(e.currentTarget);
            const data = $el.data();
            const $btnRow = $el.closest('.status-btn-row');

            if (data.type === 'ProductVariant') {
                this.changeVariantStatus($btnRow, data.id, data.status);
            } else {
                this.changeProductStatus($btnRow, data.id, data.type, data.status);
            }
        });

        // Permission Add/Remove Actions (Event Delegation for AJAX compatibility)
        $doc.on('click', '.js-add-brand-permission', (e) => this.addBrandPermission(e));
        $doc.on('click', '.js-add-access-level-permission', (e) => this.addAccessLevelPermission(e));
        $doc.on('click', '.js-add-user-permission', (e) => this.addUserPermission(e));

        $doc.on('click', '.removeBrandPermission', (e) => this.removeBrandPermission(e));
        $doc.on('click', '.js-remove-access-level-permission', (e) => this.removeAccessLevelPermission(e));
        $doc.on('click', '.js-remove-user-permission', (e) => this.removeUserPermission(e));

        // Change listeners
        $doc.on('change', '.js-toggle-access-level', (e) => this.toggleAccessLevelByBrand(e));

        // Form Submission
        $doc.on('submit', '.permissionForm', (e) => this.handleFormSubmit(e));
    },

    /**
     * Fetch the form via AJAX using Ziggy for URLs
     */
    getPermissionForm(formID, componentID, $tr, row, button) {
        const $btn = $(button);
        $btn.attr('disabled', true).find('i').addClass('fa-spin');

        // Extract context from the hidden config element in the parent Blade
        const $config = $('#permissions-config');
        const isAdmin = $config.data('admin-view');
        const userBrandID = $config.data('user-brand-id');

        // Build Save URL via Ziggy
        const saveAction = route('product.permissions.save.route', {
            componentID: componentID,
            brandID: isAdmin ? null : userBrandID
        });

        // Build Edit (HTML) URL via Ziggy
        const remoteUrl = route('product.permissions.edit.route', {
            componentID: componentID
        });

        // Create form wrapper with required context attributes
        const $form = $('<form>', {
            id: formID,
            action: saveAction,
            class: 'col-sm-8 col-sm-offset-2 well permissionForm product-permissions-container',
            'data-component-id': componentID,
            'data-admin-view': isAdmin
        });

        // Use Axios (client) to fetch HTML for better error handling than $.load
        client.get(remoteUrl).then(response => {
            // Note: client response interceptor should handle returning HTML as string
            $form.html(response);

            const saveButton = '<hr><div class="text-right"><button type="submit" class="btn btn-primary">Save Changes</button></div>';
            $form.append(saveButton);

            this.appendPermissionForm($form, $tr, row);
            $btn.attr('disabled', false).find('i').removeClass('fa-spin');
        }).catch(err => {
            console.error('Failed to load permission form', err);
            $btn.attr('disabled', false).find('i').removeClass('fa-spin');
        });
    },

    appendPermissionForm(form, $tr, row) {
        row.child(form);
        row.child.show();
        $tr.addClass('shown');
    },

    async changeVariantStatus($btnRow, id, status) {
        try {
            const url = route('product.variant.change-status.route', { VARIANT_ID: id, STATUS: status });
            const response = await client.get(url);
            this.updateToggleButtons($btnRow, response.data?.status || response.status);
        } catch (err) { console.error(err); }
    },

    async changeProductStatus($btnRow, id, type, status) {
        try {
                const confirmUrl = route('product.affected.confirm.route', { PRODUCT_ID: id, TYPE: type });
            window.affectedConfirm(confirmUrl, {}, async () => {
                const actionUrl = route('product.change-status.route', { PRODUCT_ID: id, STATUS: status });
                const response = await client.get(actionUrl);
                this.updateToggleButtons($btnRow, response.data?.status || response.status);
            });
        } catch (err) { console.error(err); }
    },

    updateToggleButtons($btnRow, newStatus) {
        if (!newStatus) return;
        const $container = $btnRow.closest('.product-permissions-container');
        const statusClasses = $container.data('status-classes') || { 'Active': 'primary', 'Inactive': 'warning', 'Deleted': 'danger' };
        const $buttons = $btnRow.find('.changeProductStatus');

        $buttons.removeClass('active is-current').attr('disabled', false);
        const $activeBtn = $btnRow.find(`[data-status="${newStatus}"]`);
        $activeBtn.addClass('active is-current').attr('disabled', true);

        const $text = $container.find('#currentStatusText');
        if ($text.length) {
            $text.removeClass((i, css) => (css.match(/(^|\s)alert-\S+/g) || []).join(' '))
                .addClass(`alert-${statusClasses[newStatus] || 'primary'}`)
                .find('strong').text(newStatus);
        }
    },

    async handleFormSubmit(e) {
        e.preventDefault();
        const $form = $(e.target);
        const $btn = $form.find('[type=submit]');
        this.removePermissionErrors($form);
        $btn.prop('disabled', true).text('Saving...');

        try {
            const response = await client.post($form.attr('action'), $form.serialize());
            if (response.status === 'success') {
                $btn.removeClass('btn btn-primary')
                    .addClass('btn-success')
                    .prop('disabled', false)
                    .html('<i class="fas fa-check"></i> Saved');

                // Restore Original State after 2 seconds
                setTimeout(() => {
                    $btn.html('Save Changes')
                        .removeClass('btn-success')
                        .addClass('btn-primary');
                }, 1000);
                // Auto-close logic if applicable
            }
        } catch (err) {
            this.displayPermissionError($form, 'Error saving permissions');
            $btn.prop('disabled', false).text('Save Failed').addClass('btn-danger');
        }
    },

    // --- Dynamic Row UI Helpers ---

    addBrandPermission(e) {
        const $container = $(e.currentTarget).closest('.product-permissions-container');
        const $brandSelect = $container.find('.brandPermBrand');
        const brandID = $brandSelect.val();
        if (!brandID) return;

        const brandName = $brandSelect.find('option:selected').text();
        const status = $container.find('.brandPermStatus').val();
        const nameKey = `permissions[brand][${brandID}]`;

        const row = `<tr>
            <td>${status}<input type="hidden" name="${nameKey}[status]" value="${status}"></td>
            <td>${brandName}<input type="hidden" name="${nameKey}[brandID]" value="${brandID}"></td>
            <td><button type="button" class="removeBrandPermission btn-link-danger" data-brand-id="${brandID}">Remove</button></td>
        </tr>`;

        $container.find('.brandPerm tr:last').before(row);
        $brandSelect.find(`option[value="${brandID}"]`).prop('disabled', true).parent().val('');
        this.resetSubmitBtn($container);
    },

    removeBrandPermission(e) {
        const $btn = $(e.currentTarget);
        const brandID = $btn.data('brand-id');
        const $container = $btn.closest('.product-permissions-container');
        $btn.closest('tr').remove();
        $container.find(`.brandPermBrand option[value="${brandID}"]`).prop('disabled', false);
        this.resetSubmitBtn($container);
    },

    addUserPermission(e) {
        const $container = $(e.currentTarget).closest('.product-permissions-container');
        const $userSelect = $container.find('.userPermUser');
        const userID = $userSelect.val();
        if (!userID) return;

        const userName = $userSelect.find('option:selected').text();
        const status = $container.find('.userPermStatus').val();
        const nameKey = `permissions[user][${userID}]`;

        const row = `<tr>
            <td>${status}<input type="hidden" name="${nameKey}[status]" value="${status}"></td>
            <td>${userName}<input type="hidden" name="${nameKey}[userID]" value="${userID}"></td>
            <td><button type="button" class="js-remove-user-permission btn-link-danger" data-user-id="${userID}">Remove</button></td>
        </tr>`;

        $container.find('.userPerm tr:last').before(row);
        $userSelect.find(`option[value="${userID}"]`).prop('disabled', true).parent().val('');
        this.resetSubmitBtn($container);
    },

    removeUserPermission(e) {
        const $btn = $(e.currentTarget);
        const userID = $btn.data('user-id');
        const $container = $btn.closest('.product-permissions-container');
        $btn.closest('tr').remove();
        $container.find(`.userPermUser option[value="${userID}"]`).prop('disabled', false);
        this.resetSubmitBtn($container);
    },

    addAccessLevelPermission(e) {
        const $container = $(e.currentTarget).closest('.product-permissions-container');
        const $brandSelect = $container.find('.accessLevelPermBrand');
        const brandID = $brandSelect.val();
        const brandName = $brandSelect.find('option:selected').text();
        const $levelSelect = $container.find('.accessLevelPermAccessLevel');
        const accessLevel = $levelSelect.val();
        const levelLabel = $levelSelect.find('option:selected').text();

        if (!brandID || !accessLevel) return;

        const status = $container.find('.accessLevelPermStatus').val();
        const nameKey = `permissions[role][${brandID}${accessLevel}]`;

        const row = `<tr>
            <td>${status}<input type="hidden" name="${nameKey}[status]" value="${status}"></td>
            <td ${$brandSelect.parent().parent().is(':visible') ? '' : 'style="display: none"'}>
                ${brandName}<input type="hidden" name="${nameKey}[brandID]" value="${brandID}">
            </td>
            <td>${levelLabel}<input type="hidden" name="${nameKey}[accessLevel]" value="${accessLevel}"></td>
            <td><a href="#" class="btn-ghost-danger js-remove-access-level-permission" data-access-level="${accessLevel}">Remove</a></td>
        </tr>`;

        $container.find('.accessLevelPerm tr:last').before(row);
        this.resetSubmitBtn($container);
    },

    toggleAccessLevelByBrand(e) {
        const $select = $(e.currentTarget);
        const brandID = $select.val();
        const $container = $select.closest('.product-permissions-container');
        const $userOptions = $container.find('.userPermUser option.users');

        if (brandID === "") {
            $userOptions.show();
        } else {
            $userOptions.hide();
            $container.find(`.userPermUser optgroup#brandGroup${brandID} option.users`).show();
        }
    },

    displayPermissionError($form, error) {
        const $list = $form.find('.permissionErrors ul');
        $list.append(`<li>${error}</li>`);
        $form.find('.permissionErrors').show();
    },

    removePermissionErrors($form) {
        $form.find('.permissionErrors ul').empty().parent().hide();
    },

    resetSubmitBtn($container) {
        $container.find('[type=submit]').text('Save').removeClass('btn-success btn-danger').addClass('btn-primary').prop('disabled', false);
    }
};

$(() => ProductPermissions.init());

export default ProductPermissions;